'use client';

import { useEffect, useRef } from 'react';
import { HeroBackground } from '@/components/layout/HeroBackground';

interface PageHeaderProps {
  title: string;
}

export function PageHeader({ title }: PageHeaderProps) {
  const sectionRef = useRef<HTMLDivElement | null>(null);
  const bgRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const section = sectionRef.current;
    const bg = bgRef.current;
    if (!section || !bg) return;

    function onScroll() {
      const rect = section!.getBoundingClientRect();
      if (rect.bottom < 0) return;
      const offset = -rect.top * 0.3;
      bg!.style.transform = `translateY(${offset}px)`;
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full overflow-hidden">
      <HeroBackground ref={bgRef} />
      <div className="relative bg-white/5 py-16 md:py-24 lg:py-32 flex items-center justify-center">
        <div className="w-fit max-w-[90%] rounded-2xl bg-white/10 backdrop-blur-sm px-8 py-4">
          <h1
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary text-center"
          >
            {title}
          </h1>
        </div>
      </div>
    </section>
  );
}
